import { render, staticRenderFns } from "./contentBox.vue?vue&type=template&id=47046d30&scoped=true&"
import script from "./contentBox.vue?vue&type=script&lang=js&"
export * from "./contentBox.vue?vue&type=script&lang=js&"
import style0 from "./contentBox.vue?vue&type=style&index=0&id=47046d30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47046d30",
  null
  
)

export default component.exports